'use client'

import { useEffect, useRef } from 'react'
import Container from '@caffeina-siad/ui-kit/src/components/atoms/GridSystem/Container.styles'
import styled from 'styled-components'

type CookieDeclarationProps = {
  locale: string
}

const COOKIEBOT_ID = process.env.NEXT_PUBLIC_COOKIEBOT_ID

const Section = styled.section`
  padding-top: ${({ theme }) => theme.rem(32)};
  padding-bottom: ${({ theme }) => theme.rem(32)};

  ${({ theme }) => theme.mediaQuery.lg(`
    padding-top: ${theme.rem(60)};
    padding-bottom: ${theme.rem(60)};
  `)}
`

function CookieDeclaration({ locale }: CookieDeclarationProps) {
  const scriptContainerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const container = scriptContainerRef.current
    if (!container || !COOKIEBOT_ID) return

    const script = document.createElement('script')
    script.id = 'CookieDeclaration'
    script.src = `https://consent.cookiebot.com/${COOKIEBOT_ID}/cd.js`
    script.type = 'text/javascript'
    script.async = true
    script.setAttribute('data-culture', locale)

    container.appendChild(script)

    return () => {
      script.remove()
    }
  }, [locale])

  if (!COOKIEBOT_ID) return null

  return (
    <Section>
      <Container>
        <div ref={scriptContainerRef} />
      </Container>
    </Section>
  )
}

export default CookieDeclaration
